import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HistoryLogActions } from './history-log.actions';
import { HistoryLogService } from '../../service/history-log.service';
import { PageInput } from '../../../../graphql/generated';

@Injectable()
export class HistoryLogEffects {
    loadRiskMapHistoryLog$ = createEffect(
        (rs: HistoryLogService = inject(HistoryLogService)) => {
            return this.actions$.pipe(

                ofType(HistoryLogActions.loadRiskMapHistoryLog),
                mergeMap(({ parameters, legalEntityId, campaignId }) =>
                    rs.fetchRiskMapHistoryLog(parameters, legalEntityId, campaignId).pipe(
                        map((historyLog) => {
                            return HistoryLogActions.loadRiskMapHistoryLogSuccess({
                                historyLog
                            });
                        }),
                        catchError((error) => of(HistoryLogActions.loadRiskMapHistoryLogFailure({ error })))
                    )
                )
            );
        },
        { functional: true }
    );

    constructor(private actions$: Actions) { }
}
